export default {
      id: "icon-circled-plus-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-circled-plus",
      toString: function () {
        return this.url;
      }
    }